import "../node_modules/react-is/index.js";
import { r as t } from "../../../_virtual/index5.js";
var r = t.exports, p = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, a = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, e = {};
e[r.ForwardRef] = p;
e[r.Memo] = a;
//# sourceMappingURL=hoist-non-react-statics.cjs.js.map
